export default __webpack_public_path__ + "static/media/youtube.c8f52198.svg";